const LINE_TYPES = {
  PRODUCT: 'PRODUCT',
  EXTRA_PRODUCT: 'EXTRA_PRODUCT',
  GREETING_CARD: 'GREETING_CARD',
  PICTURE: 'PICTURE',
  QUESTION: 'QUESTION',
  COMMENT: 'COMMENT',
  INTERNAL_COMMENT: 'INTERNAL_COMMENT',
  DEPOSIT: 'DEPOSIT',
  GROUPED_EXTRA_PRODUCTS: 'GROUPED_EXTRA_PRODUCTS',
  INVOICE_FEE: 'INVOICE_FEE'
};

export const CART = {
  LINE_TYPES
};
